import React, { FC } from 'react';
import PrintIcon from 'src/shared/material_icons/action/print.svg';
import VisibilityIcon from 'src/shared/material_icons/action/visibility.svg';
import VisibilityOffIcon from 'src/shared/material_icons/action/visibility_off.svg';
import ObjectIcon from 'src/shared/material_icons/maps/layers.svg';
import ResetIcon from 'src/shared/material_icons/content/undo.svg';
import CameraIcon from 'src/shared/material_icons/av/videocam.svg';
import PivotIcon from 'src/shared/material_icons/image/center_focus_strong.svg';
import DesignIcon from 'src/shared/material_icons/image/brush.svg';
import ColorIcon from 'src/shared/material_icons/image/palette.svg';
import SettingIcon from 'src/shared/material_icons/image/tune.svg';
import PartIcon from 'src/shared/material_icons/maps/category.svg';
import HotspotIcon from 'src/shared/material_icons/maps/pin_drop.svg';
import { ComposerActionIcon } from './composerActionCatalog';

// IL SEGNO DI UN TIPO DI AZIONE, in un posto solo: la testata della card, l'elenco dei tipi con cui ne nasce
// una nuova. Stava dentro la finestra dell'azione, che non c'è più.
export const ComposerActionGlyph: FC<{ icon: ComposerActionIcon }> = ({ icon }) => {
    switch (icon) {
        case 'visibility':
            return <VisibilityIcon />;
        case 'visibilityOff':
            return <VisibilityOffIcon />;
        case 'object':
            return <ObjectIcon />;
        case 'part':
            return <PartIcon />;
        case 'colour':
            return <ColorIcon />;
        case 'camera':
            return <CameraIcon />;
        case 'design':
            return <DesignIcon />;
        case 'pivot':
            return <PivotIcon />;
        case 'reset':
            return <ResetIcon />;
        case 'setting':
            return <SettingIcon />;
        case 'print':
            return <PrintIcon />;
        default:
            return <HotspotIcon />;
    }
};
